/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationEmptyStateContacts = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationEmptyStateContacts"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="#F4F4F5"
        d="M13.5 52.5c7-4 8.5-7.326 19.5-5.5 4.971.825 5 7.5 5 7.5s7.66 3.907 13 4.5c4.5.5 8 5 8 5H8s1.178-9.03 5.5-11.5"
      />
      <path
        fill="var(--xdlColorIllustrationBackground)"
        fillOpacity={0.01}
        d="m62.39 65.54-1.42-2.92c-.87-1.44-2.06-2.68-3.5-3.67 5.69-3.13 9.37-9.14 9.37-15.92 0-10.04-8.17-18.21-18.21-18.21-.41 0-.82.01-1.22.04C47.13 12.77 37.2 3.01 25.04 3.01S2.66 13.06 2.66 25.4c0 9.81 6.35 18.17 15.16 21.18C8.89 50.77 6.51 59.26 5.57 62.64l-.71 2.9h57.53"
      />
      <path
        fill="#BCC9D1"
        d="M32.92 43.04c0-7.33 5.03-13.47 11.83-15.2.1-.8.16-1.61.16-2.43 0-10.98-8.9-19.87-19.87-19.87S5.16 14.42 5.16 25.4s8.9 19.87 19.87 19.87c2.81 0 5.49-.59 7.91-1.65 0-.2-.03-.39-.03-.59z"
      />
      <path
        fill="#F4F4F5"
        fillRule="evenodd"
        d="M19.34 21.46c-1.73 0-3.27.76-4.32 1.97a5.7 5.7 0 0 0 4.32 1.97c1.72 0 3.27-.76 4.32-1.97a5.7 5.7 0 0 0-4.32-1.97M30.58 21.46c-1.73 0-3.27.76-4.32 1.97a5.7 5.7 0 0 0 4.32 1.97c1.72 0 3.27-.76 4.32-1.97a5.7 5.7 0 0 0-4.32-1.97M53.27 39.92c1.36 0 2.59.6 3.42 1.56a4.53 4.53 0 0 1-3.42 1.56c-1.37 0-2.59-.6-3.42-1.56a4.53 4.53 0 0 1 3.42-1.56M44.04 39.92c1.36 0 2.59.6 3.42 1.56a4.53 4.53 0 0 1-3.42 1.56c-1.37 0-2.59-.6-3.42-1.56a4.53 4.53 0 0 1 3.42-1.56"
        clipRule="evenodd"
      />
      <path
        fill="#5E737D"
        d="m24.04 23.76.29-.33-.29-.33a6.228 6.228 0 0 0-9.4 0l-.29.33.29.33a6.24 6.24 0 0 0 4.7 2.14c1.8 0 3.51-.78 4.7-2.14m-4.7 1.15c-.55 0-1.08-.11-1.6-.27.42-.24.71-.68.71-1.2s-.29-.96-.71-1.2c.51-.17 1.05-.27 1.6-.27 1.36 0 2.66.53 3.63 1.47-.97.94-2.27 1.47-3.63 1.47M35.28 23.11a6.228 6.228 0 0 0-9.4 0l-.29.33.29.33a6.24 6.24 0 0 0 4.7 2.14c1.8 0 3.51-.78 4.7-2.14l.29-.33zm-4.7 1.8c-.55 0-1.08-.11-1.6-.27.42-.24.71-.68.71-1.2s-.29-.96-.71-1.2c.51-.17 1.05-.27 1.6-.27 1.36 0 2.66.53 3.63 1.47-.97.94-2.27 1.47-3.63 1.47M24.97 28.84c-.75 0-1.35-.61-1.35-1.35h-1c0 1.3 1.06 2.35 2.35 2.35a2.36 2.36 0 0 0 2.35-2.35h-1c0 .75-.61 1.35-1.35 1.35M57.06 41.15a5.015 5.015 0 0 0-7.58 0l-.29.33.29.33a5.015 5.015 0 0 0 7.58 0l.29-.33zm-6.51.33c1.03-.94 2.53-1.21 3.85-.85-.26.2-.43.5-.43.85s.18.65.43.85c-1.32.37-2.83.09-3.85-.85M47.83 41.81l.29-.33-.29-.33a5.015 5.015 0 0 0-7.58 0l-.29.33.29.33a5.015 5.015 0 0 0 7.58 0m-6.51-.33c1.03-.94 2.53-1.21 3.85-.85-.26.2-.43.5-.43.85s.18.65.43.85c-1.32.37-2.83.09-3.85-.85M48.69 45.65c-.53 0-.97-.43-.97-.96h-1c0 1.08.88 1.96 1.97 1.96s1.97-.88 1.97-1.96h-1c0 .53-.43.96-.97.96"
      />
      <path
        fill="#5E737D"
        d="M64.83 43.03c0-8.94-7.27-16.21-16.21-16.21-1.13 0-2.24.12-3.31.34.05-.58.09-1.17.09-1.77 0-11.23-9.14-20.37-20.37-20.37S4.66 14.16 4.66 25.4s9.14 20.37 20.37 20.37c2.63 0 5.14-.52 7.45-1.43.05.65.13 1.3.26 1.93C12.62 44.83 8.76 58.61 7.49 63.18l-.17.59.96.28.17-.6c1.23-4.4 4.96-17.72 24.55-16.16 1.55 5.68 6.1 10.11 11.85 11.49-3.2.78-5.85 2.53-7.17 4.89l.87.49c1.6-2.85 5.42-4.75 9.74-4.82 4.43-.11 8.23 1.73 10.1 4.83l.86-.52c-1.46-2.41-3.94-4.09-6.98-4.84 7.18-1.66 12.56-8.1 12.56-15.78m-39.79 1.74c-10.68 0-19.37-8.69-19.37-19.37S14.35 6.03 25.04 6.03s19.37 8.69 19.37 19.37c0 .69-.06 1.37-.13 2.04-6.83 1.91-11.86 8.17-11.86 15.59 0 .08.01.16.01.25-2.28.95-4.78 1.49-7.4 1.49zm23.59 13.47c-8.38 0-15.21-6.82-15.21-15.21s6.82-15.21 15.21-15.21 15.21 6.82 15.21 15.21-6.82 15.21-15.21 15.21"
      />
    </svg>
  );
};
export default IllustrationEmptyStateContacts;
